const strings = {
  en: {
    // General UI
    languageLabel: "Language",
    loading: "Loading...",
    error: "Error",
    noResults: "No results found.",
    returnHome: "Return to Home",

    // Navigation & Header
    navCategories: "Categories",
    navContact: "Contact",
    navAbout: "About",
    navShop: "Book Shop",
	translations: "Translations", // <-- Add this!

    // Footer
    footerCopyright: "HermesReads. All rights reserved.",
    privacyPolicy: "Privacy Policy",
    about: "About",
    impressum: "Impressum",
    footerBlurb: "We offer thousands of free public domain books. Some select titles are original translations or annotated editions prepared by HermesReads partners.",

    // Homepage
    welcome: "Welcome to HermesReads",
    browseCollection: "Browse our vast collection of free books!",

    // Category Pages
    browseByCategory: "Browse by Category",
    categoriesHeading: "Categories",

    // Search Page
    searchPlaceholder: "Search for ebooks...",
    searchButton: "Search",
    searchResults: "Search Results",
    noSearchResults: "No books found for your search.",

    // Book Page & Related Books
    by: "By",
    readBook: "Read Book",
    moreBy: "More books by",
    relatedBooks: "Related Books",
    pageMode: "Page Mode",
    mode: "Mode",
    author: "Author",
    booksBy: "Books by",
	booksIn: "Books in",
    loadingAuthorData: "Loading author data…",
    noBooksFound: "No books found for",

    // Reader/EPUB
    scrollMode: "Scroll Mode",
    pagesMode: "Pages Mode",

    // Contact Form
    thankYou: "Thank You!",
    messageSent: "Your message has been sent successfully. We'll get back to you soon.",
    contactUs: "Contact Us",
    contactDescription: "If you have any questions, feel free to reach out using the form below.",
    name: "Name",
    namePlaceholder: "Enter your full name",
    email: "Email",
    emailPlaceholder: "Enter your email",
    subject: "Subject",
    subjectPlaceholder: "Enter the subject",
    message: "Message",
    messagePlaceholder: "Write your message here",
    sendMessage: "Send Message",
    sending: "Sending...",

    // About Page
    aboutPageTitle: "About HermesReads",
    aboutText: "HermesReads offers free access to thousands of public domain books.",

    // Error Messages
    bookNotFound: "Book not found.",
    failedToFetch: "Failed to fetch book data.",
    failedToLoadBook: "Failed to load book. Please try again later.",
    bookNotReady: "Book not ready",

    // Categories (ALPHABETICAL)
    Adventure: "Adventure",
    Africa: "Africa",
    "African American": "African American",
    Alchemy: "Alchemy",
    "American Civil War": "American Civil War",
    "American History": "American History",
    "American Literature": "American Literature",
    Anarchism: "Anarchism",
    "Ancient Greece": "Ancient Greece",
    Anthology: "Anthology",
    Anthropology: "Anthropology",
    Architecture: "Architecture",
    Art: "Art",
    "Asian History": "Asian History",
    Astrology: "Astrology",
    Astronomy: "Astronomy",
    "Atheism and Agnosticism": "Atheism and Agnosticism",
    Biographies: "Biographies",
    Biology: "Biology",
    Botany: "Botany",
    "British Literature": "British Literature",
    Buddhism: "Buddhism",
    Business: "Business",
    Catholic: "Catholic",
    Celtic: "Celtic",
    "Central and Northern Asia": "Central and Northern Asia",
    Chemistry: "Chemistry",
    "Children's Literature": "Children's Literature",
    Christianity: "Christianity",
    Colonialism: "Colonialism",
    "Conservatives and Reactionaries": "Conservatives and Reactionaries",
    Correspondence: "Correspondence",
    Criticism: "Criticism",
    "Death and Dying": "Death and Dying",
    Decadence: "Decadence",
    Demonology: "Demonology",
    Design: "Design",
    Detective: "Detective",
    Divination: "Divination",
    "Drama & Theatre": "Drama & Theatre",
    "Drugs and Addiction": "Drugs and Addiction",
    "Dystopian Literature": "Dystopian Literature",
    "East Asia": "East Asia",
    Economics: "Economics",
    Education: "Education",
    Enlightenment: "Enlightenment",
    Epistemology: "Epistemology",
    "Eros and Sexuality": "Eros and Sexuality",
    Essays: "Essays",
    Ethics: "Ethics",
    "Ethnology and Ethnographies": "Ethnology and Ethnographies",
    Existentialism: "Existentialism",
    "Fantasy and Fairy tales": "Fantasy and Fairy tales",
    Fashion: "Fashion",
    Feminism: "Feminism",
    "Film and Photography": "Film and Photography",
    "Food and Drink": "Food and Drink",
    "French Literature": "French Literature",
    "German Idealism": "German Idealism",
    "Gothic Literature": "Gothic Literature",
    Heresy: "Heresy",
    Hinduism: "Hinduism",
    "Historical Fiction": "Historical Fiction",
    History: "History",
    Horror: "Horror",
    Idealism: "Idealism",
    "International Relations": "International Relations",
    Islam: "Islam",
    Judaism: "Judaism",
    "Law & Justice": "Law & Justice",
    Liberalism: "Liberalism",
    Literature: "Literature",
    Logic: "Logic",
    Magic: "Magic",
    "Marxism and Socialism": "Marxism and Socialism",
    Mathematics: "Mathematics",
    Medicine: "Medicine",
    Meditation: "Meditation",
    Medieval: "Medieval",
    "Middle East": "Middle East",
    "Military Theory": "Military Theory",
    "Modernist Literature": "Modernist Literature",
    Music: "Music",
    Mysteries: "Mysteries",
    Mysticism: "Mysticism",
    "Mythology & Folklore": "Mythology & Folklore",
    Napoleonic: "Napoleonic",
    Nationalism: "Nationalism",
    Norse: "Norse",
    Novel: "Novel",
    "Occultism and Esotericism": "Occultism and Esotericism",
    Pagan: "Pagan",
    Paranormal: "Paranormal",
    Philosophy: "Philosophy",
    "Philosophy of History": "Philosophy of History",
    "Philosophy of Science": "Philosophy of Science",
    Physics: "Physics",
    Physiology: "Physiology",
    Poetry: "Poetry",
    "Political Economy": "Political Economy",
    "Political Philosophy": "Political Philosophy",
    Politics: "Politics",
    "Practical Manuals": "Practical Manuals",
    Psychoanalysis: "Psychoanalysis",
    Psychology: "Psychology",
    Realism: "Realism",
    Religion: "Religion",
    Renaissance: "Renaissance",
    Rhetoric: "Rhetoric",
    Romance: "Romance",
    "Roman - Empire and Republic": "Roman - Empire and Republic",
    Romanticism: "Romanticism",
    "Russian Literature": "Russian Literature",
    Satire: "Satire",
    Scandinavia: "Scandinavia",
    Science: "Science",
    "Science Fiction": "Science Fiction",
    "Short Stories": "Short Stories",
    "Social Philosophy": "Social Philosophy",
    Sociology: "Sociology",
    "South America": "South America",
    "South Asia": "South Asia",
    "Southeast Asia": "Southeast Asia",
    Spirituality: "Spirituality",
    Sports: "Sports",
    Sufism: "Sufism",
    Surrealism: "Surrealism",
    Technology: "Technology",
    Theology: "Theology",
    Theosophy: "Theosophy",
    Tragedy: "Tragedy",
    Transcendentalism: "Transcendentalism",
    Travel: "Travel",
    Utopia: "Utopia",
    Vitalism: "Vitalism",
    "World War 1": "World War 1",
    Zoology: "Zoology"
  },
  sv: {
    // General UI
    languageLabel: "Språk",
    loading: "Laddar...",
    error: "Fel",
    noResults: "Inga resultat hittades.",
    returnHome: "Återgå till startsidan",

    // Navigation & Header
    navCategories: "Kategorier",
    navContact: "Kontakt",
    navAbout: "Om",
    navShop: "Bokhandel",
	    translations: "Översättningar", // <-- Add this!

    // Footer
    footerCopyright: "HermesReads. Alla rättigheter förbehållna.",
    privacyPolicy: "Integritetspolicy",
    about: "Om",
    impressum: "Impressum",
    footerBlurb: "Vi erbjuder tusentals gratis böcker i public domain. Några utvalda titlar är originalöversättningar eller annoterade utgåvor framtagna av HermesReads partners.",

    // Homepage
    welcome: "Välkommen till HermesReads",
    browseCollection: "Utforska vår stora samling av gratis böcker!",

    // Category Pages
    browseByCategory: "Bläddra efter kategori",
    categoriesHeading: "Kategorier",

    // Search Page
    searchPlaceholder: "Sök efter e-böcker...",
    searchButton: "Sök",
    searchResults: "Sökresultat",
    noSearchResults: "Inga böcker hittades för din sökning.",

    // Book Page & Related Books
    by: "Av",
    readBook: "Läs boken",
    moreBy: "Fler böcker av",
    relatedBooks: "Relaterade böcker",
    pageMode: "Sidläge",
    mode: "Läge",
    author: "Författare",
    booksBy: "Böcker av",
	booksIn: "Böcker i",
    loadingAuthorData: "Laddar författardata…",
    noBooksFound: "Inga böcker hittades för",

    // Reader/EPUB
    scrollMode: "Rullningsläge",
    pagesMode: "Sidläge",

    // Contact Form
    thankYou: "Tack!",
    messageSent: "Ditt meddelande har skickats. Vi återkommer snart.",
    contactUs: "Kontakta oss",
    contactDescription: "Har du frågor? Kontakta oss gärna via formuläret nedan.",
    name: "Namn",
    namePlaceholder: "Ange ditt fullständiga namn",
    email: "E-post",
    emailPlaceholder: "Ange din e-postadress",
    subject: "Ämne",
    subjectPlaceholder: "Ange ämnet",
    message: "Meddelande",
    messagePlaceholder: "Skriv ditt meddelande här",
    sendMessage: "Skicka meddelande",
    sending: "Skickar...",

    // About Page
    aboutPageTitle: "Om HermesReads",
    aboutText: "HermesReads erbjuder fri tillgång till tusentals böcker i public domain.",

    // Error Messages
    bookNotFound: "Boken hittades inte.",
    failedToFetch: "Kunde inte hämta bokdata.",
    failedToLoadBook: "Kunde inte ladda boken. Försök igen senare.",
    bookNotReady: "Boken är inte klar",

    // Categories (ALPHABETICAL)
    Adventure: "Äventyr",
    Africa: "Afrika",
    "African American": "Afroamerikansk",
    Alchemy: "Alkemi",
    "American Civil War": "Amerikanska inbördeskriget",
    "American History": "Amerikansk historia",
    "American Literature": "Amerikansk litteratur",
    Anarchism: "Anarkism",
    "Ancient Greece": "Antika Grekland",
    Anthology: "Antologi",
    Anthropology: "Antropologi",
    Architecture: "Arkitektur",
    Art: "Konst",
    "Asian History": "Asiatisk historia",
    Astrology: "Astrologi",
    Astronomy: "Astronomi",
    "Atheism and Agnosticism": "Ateism och agnosticism",
    Biographies: "Biografier",
    Biology: "Biologi",
    Botany: "Botanik",
    "British Literature": "Brittisk litteratur",
    Buddhism: "Buddhism",
    Business: "Företagsekonomi",
    Catholic: "Katolsk",
    Celtic: "Keltisk",
    "Central and Northern Asia": "Central- och Nordasien",
    Chemistry: "Kemi",
    "Children's Literature": "Barnlitteratur",
    Christianity: "Kristendom",
    Colonialism: "Kolonialism",
    "Conservatives and Reactionaries": "Konservativa och reaktionärer",
    Correspondence: "Korrespondens",
    Criticism: "Kritik",
    "Death and Dying": "Död och döende",
    Decadence: "Dekadens",
    Demonology: "Demonologi",
    Design: "Design",
    Detective: "Detektiv",
    Divination: "Spådom",
    "Drama & Theatre": "Drama & teater",
    "Drugs and Addiction": "Droger och beroende",
    "Dystopian Literature": "Dystopisk litteratur",
    "East Asia": "Östasien",
    Economics: "Ekonomi",
    Education: "Utbildning",
    Enlightenment: "Upplysningen",
    Epistemology: "Epistemologi",
    "Eros and Sexuality": "Eros och sexualitet",
    Essays: "Essäer",
    Ethics: "Etik",
    "Ethnology and Ethnographies": "Etnologi och etnografier",
    Existentialism: "Existentialism",
    "Fantasy and Fairy tales": "Fantasy och sagor",
    Fashion: "Mode",
    Feminism: "Feminism",
    "Film and Photography": "Film och fotografi",
    "Food and Drink": "Mat och dryck",
    "French Literature": "Fransk litteratur",
    "German Idealism": "Tysk idealism",
    "Gothic Literature": "Gotisk litteratur",
    Heresy: "Kätteri",
    Hinduism: "Hinduism",
    "Historical Fiction": "Historisk skönlitteratur",
    History: "Historia",
    Horror: "Skräck",
    Idealism: "Idealism",
    "International Relations": "Internationella relationer",
    Islam: "Islam",
    Judaism: "Judaism",
    "Law & Justice": "Rätt och rättvisa",
    Liberalism: "Liberalism",
    Literature: "Litteratur",
    Logic: "Logik",
    Magic: "Magi",
    "Marxism and Socialism": "Marxism och socialism",
    Mathematics: "Matematik",
    Medicine: "Medicin",
    Meditation: "Meditation",
    Medieval: "Medeltida",
    "Middle East": "Mellanöstern",
    "Military Theory": "Militär teori",
    "Modernist Literature": "Modernistisk litteratur",
    Music: "Musik",
    Mysteries: "Mysterier",
    Mysticism: "Mysticism",
    "Mythology & Folklore": "Mytologi och folklore",
    Napoleonic: "Napoleonsk",
    Nationalism: "Nationalism",
    Norse: "Nordisk",
    Novel: "Roman",
    "Occultism and Esotericism": "Ockultism och esoterism",
    Pagan: "Hednisk",
    Paranormal: "Paranormalt",
    Philosophy: "Filosofi",
    "Philosophy of History": "Historiens filosofi",
    "Philosophy of Science": "Vetenskapens filosofi",
    Physics: "Fysik",
    Physiology: "Fysiologi",
    Poetry: "Poesi",
    "Political Economy": "Politisk ekonomi",
    "Political Philosophy": "Politisk filosofi",
    Politics: "Politik",
    "Practical Manuals": "Praktiska manualer",
    Psychoanalysis: "Psykoanalys",
    Psychology: "Psykologi",
    Realism: "Realism",
    Religion: "Religion",
    Renaissance: "Renässans",
    Rhetoric: "Retorik",
    Romance: "Romantik",
    "Roman - Empire and Republic": "Rom - Imperium och republik",
    Romanticism: "Romantik",
    "Russian Literature": "Rysk litteratur",
    Satire: "Satir",
    Scandinavia: "Skandinavien",
    Science: "Vetenskap",
    "Science Fiction": "Science fiction",
    "Short Stories": "Noveller",
    "Social Philosophy": "Social filosofi",
    Sociology: "Sociologi",
    "South America": "Sydamerika",
    "South Asia": "Sydasien",
    "Southeast Asia": "Sydostasien",
    Spirituality: "Andlighet",
    Sports: "Sport",
    Sufism: "Sufism",
    Surrealism: "Surrealism",
    Technology: "Teknik",
    Theology: "Teologi",
    Theosophy: "Teosofi",
    Tragedy: "Tragedi",
    Transcendentalism: "Transcendentalism",
    Travel: "Resor",
    Utopia: "Utopi",
    Vitalism: "Vitalism",
    "World War 1": "Första världskriget",
    Zoology: "Zoologi"
  },
  fr: {
    // General UI
    languageLabel: "Langue",
    loading: "Chargement...",
    error: "Erreur",
    noResults: "Aucun résultat trouvé.",
    returnHome: "Retour à l'accueil",

    // Navigation & Header
    navCategories: "Catégories",
    navContact: "Contact",
    navAbout: "À propos",
    navShop: "Librairie",
	translations: "Traductions",

    // Footer
    footerCopyright: "HermesReads. Tous droits réservés.",
    privacyPolicy: "Politique de confidentialité",
    about: "À propos",
    impressum: "Mentions légales",
    footerBlurb: "Nous proposons des milliers de livres gratuits du domaine public. Certains titres sont des traductions originales ou des éditions annotées préparées par les partenaires de HermesReads.",

    // Homepage
    welcome: "Bienvenue sur HermesReads",
    browseCollection: "Découvrez notre vaste collection de livres gratuits !",

    // Category Pages
    browseByCategory: "Parcourir par catégorie",
    categoriesHeading: "Catégories",

    // Search Page
    searchPlaceholder: "Rechercher des ebooks...",
    searchButton: "Rechercher",
    searchResults: "Résultats de recherche",
    noSearchResults: "Aucun livre trouvé pour votre recherche.",

    // Book Page & Related Books
    by: "Par",
    readBook: "Lire le livre",
    moreBy: "Autres livres de",
    relatedBooks: "Livres similaires",
    pageMode: "Mode page",
    mode: "Mode",
    author: "Auteur",
    booksBy: "Livres de",
	booksIn: "Livres de",
    loadingAuthorData: "Chargement des données de l'auteur…",
    noBooksFound: "Aucun livre trouvé pour",

    // Reader/EPUB
    scrollMode: "Mode défilement",
    pagesMode: "Mode pages",

    // Contact Form
    thankYou: "Merci !",
    messageSent: "Votre message a été envoyé. Nous vous répondrons bientôt.",
    contactUs: "Contactez-nous",
    contactDescription: "Si vous avez des questions, veuillez utiliser le formulaire ci-dessous.",
    name: "Nom",
    namePlaceholder: "Entrez votre nom complet",
    email: "Email",
    emailPlaceholder: "Entrez votre adresse e-mail",
    subject: "Sujet",
    subjectPlaceholder: "Entrez le sujet",
    message: "Message",
    messagePlaceholder: "Écrivez votre message ici",
    sendMessage: "Envoyer le message",
    sending: "Envoi en cours...",

    // About Page
    aboutPageTitle: "À propos de HermesReads",
    aboutText: "HermesReads offre un accès gratuit à des milliers de livres du domaine public.",

    // Error Messages
    bookNotFound: "Livre non trouvé.",
    failedToFetch: "Impossible de récupérer les données du livre.",
    failedToLoadBook: "Impossible de charger le livre. Veuillez réessayer plus tard.",
    bookNotReady: "Livre non prêt",

    // Categories (ALPHABETICAL)
    Adventure: "Aventure",
    Africa: "Afrique",
    "African American": "Afro-américain",
    Alchemy: "Alchimie",
    "American Civil War": "Guerre civile américaine",
    "American History": "Histoire américaine",
    "American Literature": "Littérature américaine",
    Anarchism: "Anarchisme",
    "Ancient Greece": "Grèce antique",
    Anthology: "Anthologie",
    Anthropology: "Anthropologie",
    Architecture: "Architecture",
    Art: "Art",
    "Asian History": "Histoire asiatique",
    Astrology: "Astrologie",
    Astronomy: "Astronomie",
    "Atheism and Agnosticism": "Athéisme et agnosticisme",
    Biographies: "Biographies",
    Biology: "Biologie",
    Botany: "Botanique",
    "British Literature": "Littérature britannique",
    Buddhism: "Bouddhisme",
    Business: "Commerce",
    Catholic: "Catholique",
    Celtic: "Celtique",
    "Central and Northern Asia": "Asie centrale et septentrionale",
    Chemistry: "Chimie",
    "Children's Literature": "Littérature jeunesse",
    Christianity: "Christianisme",
    Colonialism: "Colonialisme",
    "Conservatives and Reactionaries": "Conservateurs et réactionnaires",
    Correspondence: "Correspondance",
    Criticism: "Critique",
    "Death and Dying": "Mort et décès",
    Decadence: "Décadence",
    Demonology: "Démonologie",
    Design: "Design",
    Detective: "Détective",
    Divination: "Divination",
    "Drama & Theatre": "Drame & théâtre",
    "Drugs and Addiction": "Drogues et dépendance",
    "Dystopian Literature": "Littérature dystopique",
    "East Asia": "Asie de l'Est",
    Economics: "Économie",
    Education: "Éducation",
    Enlightenment: "Siècle des Lumières",
    Epistemology: "Épistémologie",
    "Eros and Sexuality": "Éros et sexualité",
    Essays: "Essais",
    Ethics: "Éthique",
    "Ethnology and Ethnographies": "Ethnologie et ethnographies",
    Existentialism: "Existentialisme",
    "Fantasy and Fairy tales": "Fantasy et contes de fées",
    Fashion: "Mode",
    Feminism: "Féminisme",
    "Film and Photography": "Cinéma et photographie",
    "Food and Drink": "Nourriture et boissons",
    "French Literature": "Littérature française",
    "German Idealism": "Idéalisme allemand",
    "Gothic Literature": "Littérature gothique",
    Heresy: "Hérésie",
    Hinduism: "Hindouisme",
    "Historical Fiction": "Fiction historique",
    History: "Histoire",
    Horror: "Horreur",
    Idealism: "Idéalisme",
    "International Relations": "Relations internationales",
    Islam: "Islam",
    Judaism: "Judaïsme",
    "Law & Justice": "Droit et justice",
    Liberalism: "Libéralisme",
    Literature: "Littérature",
    Logic: "Logique",
    Magic: "Magie",
    "Marxism and Socialism": "Marxisme et socialisme",
    Mathematics: "Mathématiques",
    Medicine: "Médecine",
    Meditation: "Méditation",
    Medieval: "Médiéval",
    "Middle East": "Moyen-Orient",
    "Military Theory": "Théorie militaire",
    "Modernist Literature": "Littérature moderniste",
    Music: "Musique",
    Mysteries: "Mystères",
    Mysticism: "Mysticisme",
    "Mythology & Folklore": "Mythologie & folklore",
    Napoleonic: "Napoléonien",
    Nationalism: "Nationalisme",
    Norse: "Nordique",
    Novel: "Roman",
    "Occultism and Esotericism": "Occultisme et ésotérisme",
    Pagan: "Païen",
    Paranormal: "Paranormal",
    Philosophy: "Philosophie",
    "Philosophy of History": "Philosophie de l'histoire",
    "Philosophy of Science": "Philosophie des sciences",
    Physics: "Physique",
    Physiology: "Physiologie",
    Poetry: "Poésie",
    "Political Economy": "Économie politique",
    "Political Philosophy": "Philosophie politique",
    Politics: "Politique",
    "Practical Manuals": "Manuels pratiques",
    Psychoanalysis: "Psychanalyse",
    Psychology: "Psychologie",
    Realism: "Réalisme",
    Religion: "Religion",
    Renaissance: "Renaissance",
    Rhetoric: "Rhétorique",
    Romance: "Romance",
    "Roman - Empire and Republic": "Romain - Empire et République",
    Romanticism: "Romantisme",
    "Russian Literature": "Littérature russe",
    Satire: "Satire",
    Scandinavia: "Scandinavie",
    Science: "Science",
    "Science Fiction": "Science-fiction",
    "Short Stories": "Nouvelles",
    "Social Philosophy": "Philosophie sociale",
    Sociology: "Sociologie",
    "South America": "Amérique du Sud",
    "South Asia": "Asie du Sud",
    "Southeast Asia": "Asie du Sud-Est",
    Spirituality: "Spiritualité",
    Sports: "Sports",
    Sufism: "Soufisme",
    Surrealism: "Surréalisme",
    Technology: "Technologie",
    Theology: "Théologie",
    Theosophy: "Théosophie",
    Tragedy: "Tragédie",
    Transcendentalism: "Transcendantalisme",
    Travel: "Voyage",
    Utopia: "Utopie",
    Vitalism: "Vitalisme",
    "World War 1": "Première Guerre mondiale",
    Zoology: "Zoologie"
  },
  de: {
    // General UI
    languageLabel: "Sprache",
    loading: "Laden...",
    error: "Fehler",
    noResults: "Keine Ergebnisse gefunden.",
    returnHome: "Zurück zur Startseite",

    // Navigation & Header
    navCategories: "Kategorien",
    navContact: "Kontakt",
    navAbout: "Über",
    navShop: "Buchladen",
    translations: "Übersetzungen",
	
    // Footer
    footerCopyright: "HermesReads. Alle Rechte vorbehalten.",
    privacyPolicy: "Datenschutzerklärung",
    about: "Über",
    impressum: "Impressum",
    footerBlurb: "Wir bieten Tausende kostenlose gemeinfreie Bücher. Einige ausgewählte Titel sind Originalübersetzungen oder kommentierte Ausgaben, die von HermesReads-Partnern erstellt wurden.",

    // Homepage
    welcome: "Willkommen bei HermesReads",
    browseCollection: "Entdecken Sie unsere umfangreiche Sammlung kostenloser Bücher!",

    // Category Pages
    browseByCategory: "Nach Kategorie stöbern",
    categoriesHeading: "Kategorien",

    // Search Page
    searchPlaceholder: "Nach E-Books suchen...",
    searchButton: "Suchen",
    searchResults: "Suchergebnisse",
    noSearchResults: "Keine Bücher für Ihre Suche gefunden.",

    // Book Page & Related Books
    by: "Von",
    readBook: "Buch lesen",
    moreBy: "Mehr Bücher von",
    relatedBooks: "Verwandte Bücher",
    pageMode: "Seitenmodus",
    mode: "Modus",
    author: "Autor",
    booksBy: "Bücher von",
	booksIn: "Bücher in",
    loadingAuthorData: "Laden der Autoren-Daten…",
    noBooksFound: "Keine Bücher gefunden für",

    // Reader/EPUB
    scrollMode: "Scroll-Modus",
    pagesMode: "Seitenmodus",

    // Contact Form
    thankYou: "Danke!",
    messageSent: "Ihre Nachricht wurde erfolgreich gesendet. Wir melden uns bald bei Ihnen.",
    contactUs: "Kontaktieren Sie uns",
    contactDescription: "Wenn Sie Fragen haben, nutzen Sie bitte das Formular unten.",
    name: "Name",
    namePlaceholder: "Geben Sie Ihren vollständigen Namen ein",
    email: "E-Mail",
    emailPlaceholder: "Geben Sie Ihre E-Mail-Adresse ein",
    subject: "Betreff",
    subjectPlaceholder: "Geben Sie den Betreff ein",
    message: "Nachricht",
    messagePlaceholder: "Schreiben Sie Ihre Nachricht hier",
    sendMessage: "Nachricht senden",
    sending: "Senden...",

    // About Page
    aboutPageTitle: "Über HermesReads",
    aboutText: "HermesReads bietet kostenlosen Zugang zu Tausenden gemeinfreien Büchern.",

    // Error Messages
    bookNotFound: "Buch nicht gefunden.",
    failedToFetch: "Kunde nicht hämta bokdata.",
    failedToLoadBook: "Buch konnte nicht geladen werden. Bitte versuchen Sie es später erneut.",
    bookNotReady: "Buch nicht bereit",

    // Categories (ALPHABETICAL)
    Adventure: "Abenteuer",
    Africa: "Afrika",
    "African American": "Afroamerikanisch",
    Alchemy: "Alchemie",
    "American Civil War": "Amerikanischer Bürgerkrieg",
    "American History": "Amerikanische Geschichte",
    "American Literature": "Amerikanische Literatur",
    Anarchism: "Anarchismus",
    "Ancient Greece": "Antikes Griechenland",
    Anthology: "Anthologie",
    Anthropology: "Anthropologie",
    Architecture: "Architektur",
    Art: "Kunst",
    "Asian History": "Asiatische Geschichte",
    Astrology: "Astrologie",
    Astronomy: "Astronomie",
    "Atheism and Agnosticism": "Atheismus und Agnostizismus",
    Biographies: "Biografien",
    Biology: "Biologie",
    Botany: "Botanik",
    "British Literature": "Britische Literatur",
    Buddhism: "Buddhismus",
    Business: "Wirtschaft",
    Catholic: "Katholisch",
    Celtic: "Keltisch",
    "Central and Northern Asia": "Zentral- und Nordasien",
    Chemistry: "Chemie",
    "Children's Literature": "Kinderliteratur",
    Christianity: "Christentum",
    Colonialism: "Kolonialismus",
    "Conservatives and Reactionaries": "Konservative und Reaktionäre",
    Correspondence: "Korrespondenz",
    Criticism: "Kritik",
    "Death and Dying": "Tod und Sterben",
    Decadence: "Dekadenz",
    Demonology: "Dämonologie",
    Design: "Design",
    Detective: "Detektiv",
    Divination: "Wahrsagung",
    "Drama & Theatre": "Drama & Theater",
    "Drugs and Addiction": "Drogen und Sucht",
    "Dystopian Literature": "Dystopische Literatur",
    "East Asia": "Ostasien",
    Economics: "Ökonomie",
    Education: "Bildung",
    Enlightenment: "Aufklärung",
    Epistemology: "Epistemologie",
    "Eros and Sexuality": "Eros und Sexualität",
    Essays: "Essays",
    Ethics: "Ethik",
    "Ethnology and Ethnographies": "Ethnologie und Ethnografien",
    Existentialism: "Existentialismus",
    "Fantasy and Fairy tales": "Fantasy und Märchen",
    Fashion: "Mode",
    Feminism: "Feminismus",
    "Film and Photography": "Film und Fotografie",
    "Food and Drink": "Essen und Trinken",
    "French Literature": "Französische Literatur",
    "German Idealism": "Deutscher Idealismus",
    "Gothic Literature": "Gotische Literatur",
    Heresy: "Häresie",
    Hinduism: "Hinduismus",
    "Historical Fiction": "Historische Fiktion",
    History: "Geschichte",
    Horror: "Horror",
    Idealism: "Idealismus",
    "International Relations": "Internationale Beziehungen",
    Islam: "Islam",
    Judaism: "Judentum",
    "Law & Justice": "Recht & Gerechtigkeit",
    Liberalism: "Liberalismus",
    Literature: "Literatur",
    Logic: "Logik",
    Magic: "Magie",
    "Marxism and Socialism": "Marxismus und Sozialismus",
    Mathematics: "Mathematik",
    Medicine: "Medizin",
    Meditation: "Meditation",
    Medieval: "Mittelalterlich",
    "Middle East": "Naher Osten",
    "Military Theory": "Militärtheorie",
    "Modernist Literature": "Modernistische Literatur",
    Music: "Musik",
    Mysteries: "Mysterien",
    Mysticism: "Mystik",
    "Mythology & Folklore": "Mythologie & Folklore",
    Napoleonic: "Napoleonisch",
    Nationalism: "Nationalismus",
    Norse: "Nordisch",
    Novel: "Roman",
    "Occultism and Esotericism": "Okultismus und Esoterik",
    Pagan: "Heidnisch",
    Paranormal: "Paranormal",
    Philosophy: "Philosophie",
    "Philosophy of History": "Geschichtsphilosophie",
    "Philosophy of Science": "Wissenschaftsphilosophie",
    Physics: "Physik",
    Physiology: "Physiologie",
    Poetry: "Poesie",
    "Political Economy": "Politische Ökonomie",
    "Political Philosophy": "Politische Philosophie",
    Politics: "Politik",
    "Practical Manuals": "Praktische Handbücher",
    Psychoanalysis: "Psychoanalyse",
    Psychology: "Psychologie",
    Realism: "Realismus",
    Religion: "Religion",
    Renaissance: "Renaissance",
    Rhetoric: "Rhetorik",
    Romance: "Romantik",
    "Roman - Empire and Republic": "Römisch - Imperium und Republik",
    Romanticism: "Romantik",
    "Russian Literature": "Russische Literatur",
    Satire: "Satire",
    Scandinavia: "Skandinavien",
    Science: "Wissenschaft",
    "Science Fiction": "Science-Fiction",
    "Short Stories": "Kurzgeschichten",
    "Social Philosophy": "Sozialphilosophie",
    Sociology: "Soziologie",
    "South America": "Südamerika",
    "South Asia": "Südasien",
    "Southeast Asia": "Südostasien",
    Spirituality: "Spiritualität",
    Sports: "Sport",
    Sufism: "Sufismus",
    Surrealism: "Surrealismus",
    Technology: "Technologie",
    Theology: "Theologie",
    Theosophy: "Theosophie",
    Tragedy: "Tragödie",
    Transcendentalism: "Transzendentalismus",
    Travel: "Reisen",
    Utopia: "Utopie",
    Vitalism: "Vitalismus",
    "World War 1": "Erster Weltkrieg",
    Zoology: "Zoologie"
  },
  es: {
    // General UI
    languageLabel: "Idioma",
    loading: "Cargando...",
    error: "Error",
    noResults: "No se encontraron resultados.",
    returnHome: "Volver a la página de inicio",

    // Navigation & Header
    navCategories: "Categorías",
    navContact: "Contacto",
    navAbout: "Sobre",
    navShop: "Librería",
	translations: "Traducciones",

    // Footer
    footerCopyright: "HermesReads. Todos los derechos reservados.",
    privacyPolicy: "Política de privacidad",
    about: "Sobre",
    impressum: "Aviso legal",
    footerBlurb: "Ofrecemos miles de libros gratuitos de dominio público. Algunos títulos seleccionados son traducciones originales o ediciones anotadas preparadas por socios de HermesReads.",

    // Homepage
    welcome: "Bienvenido a HermesReads",
    browseCollection: "¡Explora nuestra amplia colección de libros gratuitos!",

    // Category Pages
    browseByCategory: "Explorar por categoría",
    categoriesHeading: "Categorías",

    // Search Page
    searchPlaceholder: "Buscar ebooks...",
    searchButton: "Buscar",
    searchResults: "Resultados de búsqueda",
    noSearchResults: "No se encontraron libros para tu búsqueda.",

    // Book Page & Related Books
    by: "Por",
    readBook: "Leer libro",
    moreBy: "Más libros de",
    relatedBooks: "Libros relacionados",
    pageMode: "Modo página",
    mode: "Modo",
    author: "Autor",
    booksBy: "Libros de",
	booksIn: "Libros en",
    loadingAuthorData: "Cargando datos del autor…",
    noBooksFound: "No se encontraron libros para",

    // Reader/EPUB
    scrollMode: "Modo de desplazamiento",
    pagesMode: "Modo de páginas",

    // Contact Form
    thankYou: "¡Gracias!",
    messageSent: "Tu mensaje ha sido enviado correctamente. Nos pondremos en contacto contigo pronto.",
    contactUs: "Contáctanos",
    contactDescription: "Si tienes alguna pregunta, no dudes en contactarnos utilizando el siguiente formulario.",
    name: "Nombre",
    namePlaceholder: "Introduce tu nombre completo",
    email: "Correo electrónico",
    emailPlaceholder: "Introduce tu correo electrónico",
    subject: "Asunto",
    subjectPlaceholder: "Introduce el asunto",
    message: "Mensaje",
    messagePlaceholder: "Escribe tu mensaje aquí",
    sendMessage: "Enviar mensaje",
    sending: "Enviando...",

    // About Page
    aboutPageTitle: "Sobre HermesReads",
    aboutText: "HermesReads ofrece acceso gratuito a miles de libros de dominio público.",

    // Error Messages
    bookNotFound: "Libro no encontrado.",
    failedToFetch: "No se pudieron obtener los datos del libro.",
    failedToLoadBook: "No se pudo cargar el libro. Por favor, intenta de nuevo más tarde.",
    bookNotReady: "Libro no listo",

    // Categories (ALPHABETICAL)
    Adventure: "Aventura",
    Africa: "África",
    "African American": "Afroamericano",
    Alchemy: "Alquimia",
    "American Civil War": "Guerra Civil Americana",
    "American History": "Historia Americana",
    "American Literature": "Literatura Americana",
    Anarchism: "Anarquismo",
    "Ancient Greece": "Grecia Antigua",
    Anthology: "Antología",
    Anthropology: "Antropología",
    Architecture: "Arquitectura",
    Art: "Arte",
    "Asian History": "Historia Asiática",
    Astrology: "Astrología",
    Astronomy: "Astronomía",
    "Atheism and Agnosticism": "Ateísmo y Agnosticismo",
    Biographies: "Biografías",
    Biology: "Biología",
    Botany: "Botánica",
    "British Literature": "Literatura Británica",
    Buddhism: "Budismo",
    Business: "Negocios",
    Catholic: "Católico",
    Celtic: "Céltico",
    "Central and Northern Asia": "Asia Central y del Norte",
    Chemistry: "Química",
    "Children's Literature": "Literatura Infantil",
    Christianity: "Cristianismo",
    Colonialism: "Colonialismo",
    "Conservatives and Reactionaries": "Conservadores y Reaccionarios",
    Correspondence: "Correspondencia",
    Criticism: "Crítica",
    "Death and Dying": "Muerte y Morir",
    Decadence: "Decadencia",
    Demonology: "Demonología",
    Design: "Diseño",
    Detective: "Detective",
    Divination: "Adivinación",
    "Drama & Theatre": "Drama y Teatro",
    "Drugs and Addiction": "Drogas y Adicción",
    "Dystopian Literature": "Literatura Distópica",
    "East Asia": "Asia Oriental",
    Economics: "Economía",
    Education: "Educación",
    Enlightenment: "Ilustración",
    Epistemology: "Epistemología",
    "Eros and Sexuality": "Eros y Sexualidad",
    Essays: "Ensayos",
    Ethics: "Ética",
    "Ethnology and Ethnographies": "Etnología y Etnografías",
    Existentialism: "Existencialismo",
    "Fantasy and Fairy tales": "Fantasía y Cuentos de Hadas",
    Fashion: "Moda",
    Feminism: "Feminismo",
    "Film and Photography": "Cine y Fotografía",
    "Food and Drink": "Comida y Bebida",
    "French Literature": "Literatura Francesa",
    "German Idealism": "Idealismo Alemán",
    "Gothic Literature": "Literatura Gótica",
    Heresy: "Herejía",
    Hinduism: "Hinduismo",
    "Historical Fiction": "Ficción Histórica",
    History: "Historia",
    Horror: "Terror",
    Idealism: "Idealismo",
    "International Relations": "Relaciones Internacionales",
    Islam: "Islam",
    Judaism: "Judaísmo",
    "Law & Justice": "Ley y Justicia",
    Liberalism: "Liberalismo",
    Literature: "Literatura",
    Logic: "Lógica",
    Magic: "Magia",
    "Marxism and Socialism": "Marxismo y Socialismo",
    Mathematics: "Matemáticas",
    Medicine: "Medicina",
    Meditation: "Meditación",
    Medieval: "Medieval",
    "Middle East": "Oriente Medio",
    "Military Theory": "Teoría Militar",
    "Modernist Literature": "Literatura Modernista",
    Music: "Música",
    Mysteries: "Misterios",
    Mysticism: "Misticismo",
    "Mythology & Folklore": "Mitología y Folclore",
    Napoleonic: "Napoleónico",
    Nationalism: "Nacionalismo",
    Norse: "Nórdico",
    Novel: "Novela",
    "Occultism and Esotericism": "Ocultismo y Esoterismo",
    Pagan: "Pagano",
    Paranormal: "Paranormal",
    Philosophy: "Filosofía",
    "Philosophy of History": "Filosofía de la Historia",
    "Philosophy of Science": "Filosofía de la Ciencia",
    Physics: "Física",
    Physiology: "Fisiología",
    Poetry: "Poesía",
    "Political Economy": "Economía Política",
    "Political Philosophy": "Filosofía Política",
    Politics: "Política",
    "Practical Manuals": "Manuales Prácticos",
    Psychoanalysis: "Psicoanálisis",
    Psychology: "Psicología",
    Realism: "Realismo",
    Religion: "Religión",
    Renaissance: "Renacimiento",
    Rhetoric: "Retórica",
    Romance: "Romanticismo",
    "Roman - Empire and Republic": "Romano - Imperio y República",
    Romanticism: "Romanticismo",
    "Russian Literature": "Literatura Rusa",
    Satire: "Sátira",
    Scandinavia: "Escandinavia",
    Science: "Ciencia",
    "Science Fiction": "Ciencia Ficción",
    "Short Stories": "Cuentos Cortos",
    "Social Philosophy": "Filosofía Social",
    Sociology: "Sociología",
    "South America": "América del Sur",
    "South Asia": "Asia del Sur",
    "Southeast Asia": "Sudeste Asiático",
    Spirituality: "Espiritualidad",
    Sports: "Deportes",
    Sufism: "Sufismo",
    Surrealism: "Surrealismo",
    Technology: "Tecnología",
    Theology: "Teología",
    Theosophy: "Teosofía",
    Tragedy: "Tragedia",
    Transcendentalism: "Trascendentalismo",
    Travel: "Viajes",
    Utopia: "Utopía",
    Vitalism: "Vitalismo",
    "World War 1": "Primera Guerra Mundial",
    Zoology: "Zoología"
  }
};

export const t = (key) => {
  const lang = localStorage.getItem('lang') || 'en';
  return strings[lang]?.[key] || strings.en[key] || key;
};